export default "__VITE_ASSET__BjyaXwoV__"